const mergeListsById = (arr1, arr2) => {
    let merged = [];
    arr1.forEach((item, i) => {
        merged.push({
            ...arr1[i],
            ...(arr2.find((itmInner) => itmInner.id === arr1[i].id)) }
        );
    });
    return merged;
};

export default mergeListsById;